if (typeof boostPFSThemeConfig !== 'undefined') {
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
			// Optional
			loadProductFirst: false,
			styleScrollToTop: 'style2',
			defaultDisplay: boostPFSThemeConfig.custom.layout,
			showPlaceholderProductList: true,
            filterTreeMobileStyle:'style3',
            collapseOnMobileByDefault: true,
            enableKeepScrollbackPosition: true, // Scroll to the previous position after going back from Product page
    		keepScrollbackPositionType: 'history', // Where to save the scrollback position data: 'sessionStorage' or 'history'
		}
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;

//       	addDataLayerProduct( data );
      
		/*** Prepare data ***/
        var images = data.images_info;

        // Displaying price base on the policy of Shopify, have to multiple by 100
        var soldOut = !data.available; // Check a product is out of stock
        var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        var priceVaries = data.price_min != data.price_max; // Check a product has many prices

        // Data from tags
        var ribbonTag = data.tags.find(function(element) {
            return element.includes("RIBBON|");
        });
        var ribbonText = typeof(ribbonTag) != 'undefined' ? ribbonTag.substr(7) : '';

        if (onSale) {
            ribbonText = "Sale";
        }

        var worthTag = data.tags.find(function(element) {
            return element.includes("WORTH|");
        });
        var worthPrice = typeof(worthTag) != 'undefined' ? parseInt(worthTag.substr(6)) : 0;

        if (worthPrice == data.price_min) {
            worthPrice = 0;
        }

        var moreColoursTag = data.tags.find(function(element) {
            return element.includes("MORECOLOURS|True");
        });
        var moreColoursText = typeof(moreColoursTag) != 'undefined' ? '+ More Colours Available' : '';

        var lowStockTag = data.tags.find(function(element) {
            return element.includes("LOWSTOCK|");
        });
        var lowStockText = typeof(lowStockTag) != 'undefined' ? boostPFSThemeConfig.label.low_in_stock : '';

        var promoMessageTag = data.tags.find(function(element) {
            return element.includes("PROMOMESSAGE|");
        });
        var promoMessageText = typeof(promoMessageTag) != 'undefined' ? promoMessageTag.substr(13) : '';

        var awardTag = data.tags.find(function(element) {
            return element.includes("AWARD|");
        });
        var awardFile = typeof(awardTag) != 'undefined' ? awardTag.substr(6) : '';

        var awardShow = false;
        //if (awardFile != '') {
        //    awardShow = true;
        //}

        var parentSkuTag = data.tags.find(function(element) {
            return element.includes("PARENTSKU|");
        });
        var parentSku = typeof(parentSkuTag) != 'undefined' ? parentSkuTag.substr(10) : data.variants[0].sku;

        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        /*** End Prepare data ***/

        // Get Template

        // ADVERTS IN COLLECTIONS
        var sanitized_product_type = data.product_type.toLowerCase();
        if (sanitized_product_type == "advert") {
            var itemHtml = '<div class="grid__item">' +
                '<div class="grid-view-item product-card advert-image" style="background-image: url(' + Utils.optimizeImage(images[0]['src'], '300x') + ')">' +
//                 '<img src="' + Utils.optimizeImage(images[0]['src'], '300x') + '" />' +
                '<a class="grid-view-item__link grid-view-item__image-container full-width-link advert-url" href="' + data.body_html + '">' +
                '</a>' +
                '</div>' +
                '</div>'
            // END OF ADVERTS IN COLLECTIONS
        } else {
            if (boostPFSTemplate.hasOwnProperty('productGridItemHtmlNoPrice')) {
                var itemHtml = boostPFSTemplate.productGridItemHtmlNoPrice;
            } else {
                var itemHtml = boostPFSTemplate.productGridItemHtml;
            }
        }

      	var imgId = 'ProductCardImage-' + data.id;
        var wrapperId = 'ProductCardImageWrapper-' + data.id;
        if (sanitized_product_type != "advert") {
            var itemSoldOutClass = soldOut ? 'grid-view-item--sold-out' : '';
            itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
        }
        // Build Image style
        var imageStyle = buildImageStyle(data);
        itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

        // Add Images and ribbon
        var aspect_ratio = '';
        var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
        itemImagesHtml += '<span class="smartwishlist" data-product="' + data.id + '" data-variant="' + data['variants'][0].id + '"></span>';
        itemImagesHtml += '<div style="padding-top:';
        if (images.length > 0) {
            aspect_ratio = images[0]['width'] / images[0]['height'];
            itemImagesHtml += 1 / aspect_ratio * 100;
        } else {
            itemImagesHtml += 100;
        }
        itemImagesHtml += '%;">';
        itemImagesHtml += '<img id="' + imgId + '" ' +
            'class="grid-view-item__image lazyload" ' +
            //'src="' + this.getFeaturedImage(images, '600x800') + '" ' +
            'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
            'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
            'data-aspectratio="' + aspect_ratio + '" ' +
            'data-sizes="auto" ' +
            'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
        if (ribbonText) {
            var onSaleClass = onSale ? ' price--on-sale' : '';
            var ribbonColourBg = "#ECAC2D";
            var ribbonColourText = "#3d3e45";

            if (ribbonText == "New arrivals") {
                ribbonColourBg = "#1F6276";
                ribbonColourText = "#FFFFFF";
            }

            if (ribbonText == "Price match") {
                ribbonColourBg = "#497297";
                ribbonColourText = "#FFFFFF";
            }

            if (ribbonText == "3 for 2") {
                ribbonColourBg = "#497297";
                ribbonColourText = "#FFFFFF";
            }

            if (ribbonText == "Sale") {
                ribbonColourBg = "#A42337";
                ribbonColourText = "#FFFFFF";
            }

            itemImagesHtml += '<div style="color:' + ribbonColourText + '; background-color:' + ribbonColourBg + ';" class="ribbon' + onSaleClass + '">' + ribbonText + '</div>';
        }

        if (awardShow) {
            var path = boostPFSAppConfig.general.file_url;
            if (path.indexOf("?") > 0) {
                var cleanPath = path.substring(0, path.indexOf("?"));
            }
            itemImagesHtml += '<div class="award-logo">';
            itemImagesHtml += '<img src="' + cleanPath + '' + awardFile + '" alt="award logo">';
            itemImagesHtml += '</div>';
        }

        itemImagesHtml += '</div>';

        var image_size = boostPFSThemeConfig.custom.max_height + 'x' + boostPFSThemeConfig.custom.max_height;
        var max_width = images.length > 0 ? boostPFSThemeConfig.custom.max_height * aspect_ratio : 0;
        itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

        // Add Price
        var itemPriceHtml = buildPrice(data, onSale, priceVaries, worthPrice);
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add more colours
        var itemMoreColoursHtml = buildMessage(moreColoursText, "colours", "grid");
        itemHtml = itemHtml.replace(/{{itemMoreColoursLabel}}/g, itemMoreColoursHtml);

        // Add inventory
        if (data.available > 0) {
            if (data.variants.length < 2) {
                var itemInventoryHtml = buildMessage(lowStockText, "inventory", "grid");
            } else {
                var itemInventoryHtml = "";
            }
            itemHtml = itemHtml.replace(/{{itemInventory}}/g, itemInventoryHtml);
        } else {
            var itemInventoryHtml = buildMessage(boostPFSThemeConfig.label.out_of_stock, "inventory", "grid");
            itemHtml = itemHtml.replace(/{{itemInventory}}/g, itemInventoryHtml);
        }

        // Add promo
        var itemPromoHtml = buildMessage(promoMessageText, "promo", "grid");
        itemHtml = itemHtml.replace(/{{itemPromo}}/g, itemPromoHtml);

        // Add main attribute
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemSku}}/g, parentSku);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemWorthPrice}}/g, worthPrice);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}
    
    function buildMessage(message, className, layout) {
        var msgHtml = '';

        if (message) {
          	msgHtml += '<div class="'+ layout +'-view-item__msg '+ layout +'-view-item__'+ className +'">'+ message +'</div>'
        }

        return msgHtml;
    }

	// Build Image style
	function buildImageStyle(data) {
        var images = data.images_info;
        var imgId = 'ProductCardImage-' + data.id;
        var wrapperId = 'ProductCardImageWrapper-' + data.id;
        var imageStyle = '';
        if (images.length > 0) {
            var image = images[0];
            var width = boostPFSThemeConfig.custom.max_height;
            var height = boostPFSThemeConfig.custom.max_height;
            var aspect_ratio = image.width / image.height;
            var small_style = true;
            var container_aspect_ratio = width * 1.0 / height;

            if (image.aspect_ratio < 1.0) {
                var maximum_width = height * aspect_ratio;
                if (image.height <= height) {
                    var maximum_height = image.height;
                    maximum_width = image.width;
                } else {
                    var maximum_height = height;
                }
            } else if (aspect_ratio < container_aspect_ratio) {
                var maximum_height = height / aspect_ratio;
                if (image.height <= height) {
                    var maximum_height = image.height;
                    var maximum_width = image.width;
                } else {
                    var maximum_height = height;
                    var maximum_width = height * aspect_ratio;
                }
            } else {
                var maximum_height = height / aspect_ratio;
                if (image.width <= width) {
                    maximum_height = image.height;
                    var maximum_width = image.width
                } else {
                    var maximum_width = width;
                    maximum_height = maximum_width / aspect_ratio;
                }
            }

            imageStyle += '<style>';
            if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
            imageStyle += '#' + imgId + ' {' +
                'max-width: ' + maximum_width + 'px;' +
                'max-height: ' + maximum_height + 'px;' +
                '}' +
                '#' + wrapperId + ' {' +
                'max-width: ' + maximum_width + 'px;' +
                'max-height: ' + maximum_height + 'px;' +
                '}';
            if (small_style) imageStyle += '}';

            if (small_style) {
                if (aspect_ratio < 1) {
                    maximum_width = 750 * aspect_ratio;
                } else {
                    if (image.width < 750) {
                        maximum_width = image.width;
                    } else {
                        maximum_width = 750;
                    }
                }
                imageStyle += '@media screen and (max-width: 749px) {'
                imageStyle += '#' + imgId + ' {' +
                    'max-width: ' + maximum_width + 'px;' +
                    'max-height: 750px;' +
                    '}' +
                    '#' + wrapperId + ' {' +
                    'max-width: ' + maximum_width + 'px;' +
                    '}';
                imageStyle += '}';
            }
            imageStyle += '</style>';
        }
        return imageStyle;
    }

	function buildPrice(data, onSale, priceVaries, worthPrice) {

        var priceHtml = '',
            onWorthClass = worthPrice > 0 ? ' price--on-worth' : '',
            onSaleClass = onSale ? ' price--on-sale' : '';

        priceHtml += '<dl class="price' + onSaleClass + '' + onWorthClass + '" data-price>';

        if (onSale || worthPrice > 0) {
            priceHtml += '<div class="price__sale">';
            priceHtml += '<dt>';
            priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSThemeConfig.label.sale_price + '</span>';
            priceHtml += '</dt>';
            priceHtml += '<dd>';
            if (priceVaries) {
                priceHtml += '<span class="price-item__label" aria-hidden="true">From</span>';
            }
            priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
            priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat, 1);
            priceHtml += '</span> ';
            priceHtml += '</dd>';
            priceHtml += '</div>';
        }

        priceHtml += '<div class="price__regular">';
        priceHtml += '<dt>';
        priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSThemeConfig.label.regular_price + '</span>';
        priceHtml += '</dt>';
        priceHtml += '<dd>';
      console.log(worthPrice);
        if (!onSale && priceVaries) {
            priceHtml += '<span class="price-item__label" aria-hidden="true">From</span>';
        }
        if (!onSale && worthPrice > 0) {
            priceHtml += '<span class="price-item__label" aria-hidden="true">worth</span>';
        }
        priceHtml += ' <span class="price-item price-item--regular" data-regular-price>';
        if (onSale) {
            priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat, true);
        } else {
            if (worthPrice > 0) {
                priceHtml += Utils.formatMoney(worthPrice, Globals.moneyFormat, true);
            } else {
                priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat, true);
            }
        }
        priceHtml += '</span>';
        priceHtml += '</dd>';
        priceHtml += '</div>';

        if (onSale || worthPrice > 0) {
            priceHtml += '<div class="price__save">';
            priceHtml += '<dt>';
            priceHtml += '<span class="visually-hidden visually-hidden--inline">Save price</span>';
            priceHtml += '</dt>';
            priceHtml += '<dd>';
            priceHtml += '<span class="price-item price-item--save" data-save-price>Save ';

            if (onSale) {
                var saveValue = data.compare_at_price_min - data.price_min;
            } else {
                var saveValue = worthPrice - data.price_min;
            }

            priceHtml += Utils.formatMoney(saveValue, Globals.moneyFormat, true);
            priceHtml += '</span>';
            priceHtml += '</dd>';
            priceHtml += '</div>';
        }

        priceHtml += '</dl>';

        return priceHtml;
    }

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
//             if (currentPage - 4 > 0) {
//                 beforeCurrentPageArr.unshift('...');
//             }
//             if (currentPage - 4 >= 0) {
//                 beforeCurrentPageArr.unshift(1);
//             }
            beforeCurrentPageArr.push(currentPage); 
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter); 
            }
//             if (currentPage + 3 < totalPage) {
//                 afterCurrentPageArr.push('...');
//             }
//             if (currentPage + 3 <= totalPage) {
//                 afterCurrentPageArr.push(totalPage);
//             }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
        if (data.event_type != 'init' && typeof ReloadSmartWishlist !== 'undefined') { ReloadSmartWishlist(); }
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
  
        if (Utils.isSearchPage()) {
          	if (data.total_product == 1) {
                totalProduct = boostPFSThemeConfig.label.results_with_count.replace(/{{ count }}/g, data.total_product);
            } else {
                totalProduct = boostPFSThemeConfig.label.results_with_count_many.replace(/{{ count }}/g, data.total_product);
            }
          	totalProduct = totalProduct.replace(/{{ terms }}/g, Utils.getSearchTerm());
			jQ('.bc-sf-search-result-number').html(totalProduct);
        }
      
        // Sets advert heights after page loaded
        function advertHeight() {
            var gridHeight = document.querySelectorAll('.grid-view-item.product-card:not(.advert-image)');
            if (gridHeight.length >= 1) { 
                var gridHeightResult = gridHeight[0].parentElement.clientHeight;
                var adverts = document.querySelectorAll('.advert-image')
                adverts.forEach(element => element.style.height = gridHeightResult+'px')
            }
        };
        window.addEventListener("load", advertHeight) ;
        window.addEventListener("resize", advertHeight) ;
	};
})();